import { render, staticRenderFns } from "./FilterCompanyProductCategories.vue?vue&type=template&id=1348557f&"
import script from "./FilterCompanyProductCategories.vue?vue&type=script&lang=js&"
export * from "./FilterCompanyProductCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports